import React from "react";
import ApiSettings from "./ApiSettings.js";
import FtpSettings from "./FtpSettings.js";
import Integration from "./Integration.js";
import { useParams } from "react-router-dom";

const ForDevelopers = ({ availableAllPages, userData }) => {
  const params = useParams();
  return (
    <div className="for-developer-container">
      <div className="main">
        {params.profilePage ? (
          params.profilePage === "api" ? (
            <ApiSettings
              availableAllPages={availableAllPages}
              userData={userData}
            />
          ) : params.profilePage === "ftp" ? (
            <FtpSettings
              availableAllPages={availableAllPages}
              userData={userData}
            />
          ) : params.profilePage === "integration" ? (
            <Integration userData={userData} />
          ) : null
        ) : null}
      </div>
    </div>
  );
};

export default ForDevelopers;
